var fieldUtil = require('./field');
var jsonUtil = require('./json');
var $ = require('@alife/alpha-jquery/jquery');

/**
 * 扫描dom容器，将其中的control转化为map；map的key为字段name，value为字段value
 * @param con dom容器
 * @returns {{}}
 */
function elementMap(con) {
    var els = $(con).find('input,select,textarea').get(),
        map = {};
    var i = 0;
    while (i < els.length) {
        var $el = $(els[i]),
            name = $el.attr('name'),
            type = fieldUtil.type($el);
        if (type == 'radio' || type == 'checkbox') {
            var j = i + 1,
                tmp = $el.get();
            while (j < els.length) {
                if (name == els[j].getAttribute('name')) {
                    tmp[tmp.length] = els[j];
                    els.splice(j, 1);	// els.length 会自动减少1
                } else {
                    j++;
                }
            }
            $el = $(tmp);
        }
        if (name) {
            map[name] = $el;
        }
        i++;
    }
    return map;
}

function setForm(form, json) {
    var fieldsMap = elementMap(form);
    $.each(fieldsMap, function (name, element) {
        var value = jsonUtil.pathValue(json, name);
        if (value !== undefined) {
            fieldUtil.val(element, value);
        }
    });
}

/**
 * 将form dom 序列化为json对象
 */
function getForm(form) {
    var json = {};
    var fieldsMap = elementMap(form);
    $.each(fieldsMap, function (name, element) {
        var value = fieldUtil.val(element);
        jsonUtil.pathValue(json, name, value);
    });
    return json;
}

module.exports = {
    getForm: getForm,
    setForm: setForm
};

